import React, { useState } from "react";
import { connect } from "react-redux";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { getPhotoButtonHoverSetting, getPhotoTagSetting, photoToolButtonHoverOptions, getPhotoNumbersSetting, photoToolPhotoNumberingOptions, getPhotoSizeSetting, photoSizeMetaData, PhotoSizeMeta, photoTagHoverSettings } from "components/Photos/PhotoTool/Shared";
import { savePreference } from "actions/preferences";
import { PhotoButtonSetting, PhotoNumberingSetting, PhotoSizeSetting, PhotoTagSetting } from "typeConstants/preferenceTypes";
import { UserPreference } from "interfaces/Mueller.Business.Models";

interface IPhotoTagSettingsProps {
  preferences: UserPreference[],
  savePreference: (code: string, value: string, callback?: () => void) => void
}

const PhotoTagSettings = ({preferences, savePreference}: IPhotoTagSettingsProps) => {
  const [hoverSetting, setHoverSetting] = useState(getPhotoTagSetting(preferences));
  const [photoNumbersSetting, setPhotoNumbersSetting] = useState(getPhotoNumbersSetting(preferences));
  const [buttonSetting, setButtonSetting] = useState(getPhotoButtonHoverSetting(preferences));
  const [sizeSetting, setSizeSetting] = useState<PhotoSizeMeta>(getPhotoSizeSetting(preferences));

  return (
    <div className={"photo-tag-settings"}>
      <FormControl className={"mueller-radio"}>
        <FormLabel>Photo Sizes</FormLabel>
        <RadioGroup
          row
          name="photo-size-options"
          value={sizeSetting.preferenceCode}
          onChange={(e) => {
            const newSizeSetting = e.target.value;
            if (newSizeSetting !== sizeSetting.preferenceCode) {
              savePreference(PhotoSizeSetting, newSizeSetting);
              setSizeSetting(photoSizeMetaData[newSizeSetting]);
            }
          }}
        >
          <FormControlLabel value={photoSizeMetaData.EXTRA_SMALL.preferenceCode} control={<Radio />} label={photoSizeMetaData.EXTRA_SMALL.label} />
          <FormControlLabel value={photoSizeMetaData.SMALL.preferenceCode} control={<Radio />} label={photoSizeMetaData.SMALL.label} />
          <FormControlLabel value={photoSizeMetaData.MEDIUM.preferenceCode} control={<Radio />} label={photoSizeMetaData.MEDIUM.label} />
          <FormControlLabel value={photoSizeMetaData.LARGE.preferenceCode} control={<Radio />} label={photoSizeMetaData.LARGE.label} />
          <FormControlLabel value={photoSizeMetaData.EXTRA_LARGE.preferenceCode} control={<Radio />} label={photoSizeMetaData.EXTRA_LARGE.label} />
        </RadioGroup>
      </FormControl>
      <FormControl className={"mueller-radio"}>
        <FormLabel>Photo Tags</FormLabel>
        <RadioGroup
          row
          name="hover-options"
          value={hoverSetting}
          onChange={(e) => {
            const newHoverSetting = e.target.value;
            if (newHoverSetting !== hoverSetting) {
              savePreference(PhotoTagSetting, newHoverSetting);
              setHoverSetting(newHoverSetting);
            }
          }}
        >
          <FormControlLabel value={photoTagHoverSettings.HIDE} control={<Radio />} label="Hide" />
          <FormControlLabel value={photoTagHoverSettings.HOVER} control={<Radio />} label="Show on Hover" />
          <FormControlLabel value={photoTagHoverSettings.SHOW} control={<Radio />} label="Show" />
        </RadioGroup>
      </FormControl>
      <FormControl className={"mueller-radio"}>
        <FormLabel>Photo Numbering</FormLabel>
        <RadioGroup
          row
          name="photo-numbering"
          value={photoNumbersSetting}
          onChange={(e) => {
            const newPhotoNumbersSetting = e.target.value;
            if (newPhotoNumbersSetting !== photoNumbersSetting) {
              savePreference(PhotoNumberingSetting, newPhotoNumbersSetting);
              setPhotoNumbersSetting(newPhotoNumbersSetting);
            }
          }}
        >
          <FormControlLabel value={photoToolPhotoNumberingOptions.HIDE_NUMBERS} control={<Radio />} label="Hide" />
          <FormControlLabel value={photoToolPhotoNumberingOptions.SHOW_ON_HOVER} control={<Radio />} label="Show on Hover" />
          <FormControlLabel value={photoToolPhotoNumberingOptions.SHOW_NUMBERS_ALWAYS} control={<Radio />} label="Show" />
        </RadioGroup>
      </FormControl>
      <FormControl className={"mueller-radio"}>
        <FormLabel>Buttons</FormLabel>
        <RadioGroup
          row
          name="button-options"
          value={buttonSetting}
          onChange={(e) => {
            const newButtonSetting = e.target.value;
            if (newButtonSetting !== buttonSetting) {
              savePreference(PhotoButtonSetting, newButtonSetting);
              setButtonSetting(newButtonSetting);
            }
          }}
        >
          <FormControlLabel value={photoToolButtonHoverOptions.SHOW_ON_HOVER} control={<Radio />} label="Show on Hover" />
          <FormControlLabel value={photoToolButtonHoverOptions.SHOW_ALWAYS} control={<Radio />} label="Show" />
        </RadioGroup>
      </FormControl>
    </div>
  );
};

const mapStateToProps = state => ({
  preferences: state.preferences
});

const mapDispatchToProps = dispatch => ({
  savePreference(code, value, callback) {
    dispatch(savePreference(code, value, callback));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PhotoTagSettings);
